var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ci-info',{staticClass:"ci-success",attrs:{"title":_vm.contact.success_title,"content":_vm.contact.success_text,"action":"Voltar para o site"},on:{"callback":function($event){return _vm.$router.push({ name: 'home' })}}})}
var staticRenderFns = []

export { render, staticRenderFns }